import React from "react";
import Cart from "../Cart/Cart";

const CartWidget = () => {
    return (
        <div>
            <Cart />
        </div>
    );
};

export default CartWidget;
